import i18n from "i18next";
class ResponseUserAccountModel {
    constructor({
                    id = '',
                    accountId = '',
                    iban = '',
                    bban = '',
                    currency = '',
                    name = '',
                    product = '',
                    cashAccountType = '',
                    status = '', 
                    bic = '',
                    usage = '',             
                } = {}) {
        this.id = id;
        this.accountId = accountId;
        this.iban = iban;
        this.bban = bban;
        this.currency = currency;
        this.name = name;
        this.product = product;
        this.cashAccountType = cashAccountType;
        this.status = status;
        this.bic = bic;
        this.usage = usage;     
    }

    static getAttributes(filter = null, validationSchema = null) {

        const attributes =  {
            id :{
                'label': 'ID',
                'sortable': true,
                'sortField': 'id',
                'value': (item) => item.id || "",
            },
            accountId :{
                'label': i18n.t('userSetting.accountId'),
                'sortable': true,
                'sortField': 'visualId',
                'value': (item) => item.accountId || "",
            },
            iban :{
                'label': "IBAN",
                'sortable': true,
                'sortField': 'visualId',
                'value': (item) => item.iban || "",
            },
            bban: {
                'label': 'BBAN',
                'sortable': true,
                'sortField': 'userId',
                'value': (item) => item.bban || "",
            },
            name: {
                'label': i18n.t('userSetting.name'),
                'sortable': true,
                'sortField': 'userName',
                'value': (item) => item.name || "",
            },
            product: {
                'label': i18n.t('userSetting.product'),
                'sortable': true,
                'sortField': 'orgId',
                'value': (item) => item.product || "",
            },
            cashAccountType: {
                'label': i18n.t('userSetting.cashAccountType'),
                'sortable': true,
                'sortField': 'orgName',
                'value': (item) => item.cashAccountType || "",
            },
            status: {
                'label': i18n.t('modelLabel.status'),
                'sortable': true,
                'sortField': 'costPlace',
                'value': (item) => item.status || "",
            },
             bic :{
                'label': "Bic",
                'sortable': true,
                'sortField': 'visualId',
                'value': (item) => item.bic || "",
            },
            usage: {
                'label': i18n.t('userSetting.usage'),
                'sortable': true,
                'sortField': 'costBearerId',
                'value': (item) => item.usage || "",
            },
           
        };

        return attributes;
    }
}

export default ResponseUserAccountModel;